"use client";

import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

export default function RecaptchaProvider({ children }) {
  return (
    <GoogleReCaptchaProvider
      language="sv-SE"
      reCaptchaKey="6Lct_94nAAAAAFzcHHn1Ry8TnZ8Y5tKBydSnViT8"
      scriptProps={{
        async: true,
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
}
